import { RootState } from "reducers/init"

export const createLoadingSelector =
  (actions: string[]) =>
  (state: RootState): boolean =>
    actions.some(action => state.loader[action])
